import {BaseFormModel} from './base-form-model';
import {MenuItemPrice} from './menu-item-price';

export class MenuItemToppingPrice extends BaseFormModel<MenuItemToppingPrice> {
    id: number;
    menuItemPrice: MenuItemPrice;
    price: number;

    init(): void {
        this.menuItemPrice = !!this.menuItemPrice ? new MenuItemPrice(this.menuItemPrice) : null;
    }
}
